import CalculatorMobileFilter from "./calculatorMobileFiter";
import CalculatorResults from "../calculatorResults";

const CalculatorMobileLayout = ({
    formView,
    defaultData,
    backToFilterView,
    moveToFormView,
    buttonLoading,
    dropDownDataLoading,
    tourSitesAndActivities
}) => {
    return (
        <>
            {
                formView
                ?
                <CalculatorResults backToFilterView={backToFilterView}/>
                :
                <CalculatorMobileFilter
                    defaultData={defaultData} 
                    moveToFormView={moveToFormView}
                    buttonLoading={buttonLoading}
                    dropDownDataLoading={dropDownDataLoading}
                    tourSitesAndActivities={tourSitesAndActivities}
                />
            }
        </>
    );
}

export default CalculatorMobileLayout;